import * as ngCore from '@angular/core'
import * as ents from '@attain-apps/entities'
import * as ds from '@attain-apps/fe/web/main/lib/design'

import * as state from '../../../../../../../../state'
import * as widget from '../../../widget'

@ngCore.Component({
  imports: [
    ds.overlay.centered.Component,
    ds.layout.widget.Component,
    widget.Component,
    ds.button.Component,
  ],
  selector: 'atn-mosaic-modal',
  standalone: true,
  styleUrl: './component.scss',
  templateUrl: './component.html',
})
export class Component {
  /** Exposing widget type enum @see {@link ents.core.mosaic.Widget.Type}  */
  public WidgetTypeEnum = ents.core.mosaic.Widget.Type

  /** @see {@link state.mosaic.endUser.currentRendering.Feature} */
  public readonly currentRendering = ngCore.inject(
    state.mosaic.endUser.currentRendering.Feature,
  )

  /** Handling backdrop click event of {@link ds.overlay.centered.Component} */
  public backdropClickHandler(): void {
    this.currentRendering.subfeatures.modal.actions.setModal
      .from('Mosaic.CurrentRendering.Modal.Backdrop.Clicked')
      .dispatch({ widgetRef: undefined })
  }
}
